import Vue from 'vue';
import { has, isArray } from 'lodash';
import moment from 'moment';

import { handleError } from '@/utils/exception_handler';
import FetchingCache from '@/services/FetchingCache';

// STATE
export const fetchState = {
  fetching: false,
  fetchLog: {},
};

// GETTERS
export const fetchGetters = {
  fetching: state => state.fetching,
  fetchLog: state => state.fetchLog,
};

// MUTATIONS
export const buildFetchMutations = (mutationNames) => {
  const mutations = {};

  const buildLog = () => ({ time: moment() });

  mutationNames.forEach((mutation) => {
    mutations[`${mutation}Pending`] = (state) => {
      Vue.set(state, 'fetching', true);
    };

    mutations[`${mutation}Success`] = (state, payload) => {
      Vue.set(state, 'fetching', false);

      const logs = {};
      if (isArray(payload)) {
        payload.forEach((entity) => {
          logs[entity.id] = buildLog();
        });
      } else {
        logs[payload.id] = buildLog();
      }

      Vue.set(state, 'fetchLog', { ...state.fetchLog, ...logs });
    };

    mutations[`${mutation}Error`] = (state) => {
      Vue.set(state, 'fetching', false);
    };
  });

  return mutations;
};

// ACTIONS
export const fetch = (context, args) => {
  const { commit, dispatch } = context;
  const { api, entities, endpoint, params, cache = null, mutation = null, successCallback = null, errorCallback = null } = args;
  const mutationPrefix = mutation || endpoint;
  const fetchingCache = (cache && !cache.disable) ? new FetchingCache({ entities, endpoint, params }, cache) : null;
  let promise = null;

  if (!has(api, endpoint)) throw new Error(`Endpoint ${endpoint} not found`);

  commit(`${mutationPrefix}Pending`);

  // If caching enabled and valid, retrieve from cache
  if (fetchingCache && fetchingCache.isValid()) {
    promise = fetchingCache.retrieve();
  } else {
    promise = api[endpoint](params);
  }

  return promise
    .then((response) => {
      const data = response.entities || response.entity;

      if (fetchingCache) fetchingCache.store(response);

      dispatch('insert', { data });

      commit(`${mutationPrefix}Success`, data);

      if (successCallback) successCallback(response);

      return { status: true, data: response };
    }, handleError(context, `${mutationPrefix}Error`, errorCallback))
    .catch(handleError(context, `${mutationPrefix}Error`, errorCallback));
};



// WEBPACK FOOTER //
// ./src/store/extensions/fetch.js